import Flickity from "flickity"
import "flickity/dist/flickity.min.css"

class Carousel {
    constructor() {

        var partnerCarousel = new Flickity( '.carousel', {
            wrapAround: true,
            autoPlay: true,
            pageDots: false,
            contain: true,
            cellAlign: 'left'
        });

    }
}


export default Carousel